import { useReferralTracking } from '@/hooks/useReferralTracking';

/**
 * Component that tracks referral codes from URL params
 * Must be rendered inside BrowserRouter
 */
export default function ReferralTracker() {
  useReferralTracking();
  return null;
}
